import type { IUserMilestone } from '../../IUserMilestone';

/**
 * Set when the retailer views the tooltip for the Insider Free Shipping Threshold coverage badge
 */
export const INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN =
  'INSIDER_THRESHOLD_BADGE_TOOLTIP_SEEN' as IUserMilestone.RetailerMilestone;
